import * as React from "react";
import protectedRoute from "../../protectedRoute";
import {
  CssButtonSignIn,
  CssLoginTitleTypography,
  ValidationTextField,
} from "../../styles/styled";
import Box from "@mui/material/Box";
import { styles } from "../../Form";

function ChangeNewPassword({ updateFormState, changePassword }) {
  return (
    <React.Fragment>
      <Box
        sx={{
          position: "absolute",
          top: "30%",
          bottom: "50%",
          left: 0,
          right: 0,
          margin: "auto",
          minWidth: "1200px",
        }}
      >
        <div style={styles.signInContainer}>
          <Box
            style={{
              backgroundColor: "#26890d",
              position: "absolute",
              width: "480px",
              top: "0",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <CssLoginTitleTypography>パスワード変更</CssLoginTitleTypography>
          </Box>
          <Box style={{ height: "30px" }}></Box>
          <label style={styles.label}>旧パスワード</label>
          <ValidationTextField
            id="changepassOldPassword"
            defaultValue=""
            size="small"
            type="password"
            name="oldPassword"
            onChange={(e) => {
              e.persist();
              updateFormState(e);
            }}
          />
          <label style={styles.label}>新パスワード</label>
          <ValidationTextField
            id="changepassNewPassword"
            defaultValue=""
            size="small"
            type="password"
            name="newPassword"
            onChange={(e) => {
              e.persist();
              updateFormState(e);
            }}
          />
          <CssButtonSignIn
            variant="contained"
            size="large"
            color="success"
            onClick={changePassword}
          >
            変更
          </CssButtonSignIn>
        </div>
      </Box>
    </React.Fragment>
  );
}

export default protectedRoute(ChangeNewPassword);
